import { BsEyeFill, BsFillSuitHeartFill } from "react-icons/bs";
import { ImBubbles } from "react-icons/im";

export const Metadata = ({
  views,
  comments,
  likes,
  showText,
  className = "",
}: {
  views: number;
  comments: number;
  likes: number;
  showText?: boolean;
  className?: string;
}) => {
  return (
    <div className="flex flex-row font-medium">
      <span className={` ${className}`}>
        <BsEyeFill className={" mt-[-2px] inline-block pl-[3px] pr-[3px]"} size={18} />
        {views}
        {showText && <span className="mx-1 hidden sm:inline">Views</span>}
      </span>
      {!!comments && (
        <span className={` pl-2 ${className}`}>
          <ImBubbles className={" mt-[-2px] inline-block pl-[3px] pr-[3px]"} size={18} />
          {comments}
          {showText && <span className="mx-1 hidden sm:inline">Comments</span>}
        </span>
      )}
      {!!likes && (
        <span className={` pl-2 ${className}`}>
          <BsFillSuitHeartFill className={" mt-[-2px] inline-block pl-[3px] pr-[3px]"} size={18} />
          {likes}
          {showText && <span className="mx-1 hidden sm:inline">Likes</span>}
        </span>
      )}
    </div>
  );
};
